export default __webpack_public_path__ + "static/AcompanheObra-33def923d02fe356cdbbaf9c4398895c.svg";